import { useEffect } from 'react';

import { Loader } from 'components/loader';
import { IWebviewPropsWeb } from 'pages/campaigns/types';
import { theme } from 'styles/configure-theme';

import { listenToMessagesFromOrigin } from './listeners';

export const WebView = ({
  listenForMessage,
  externalUrl,
  onLoadEnd,
  iframeLoaded,
  webViewRef,
  loadingMessage,
  queryParam,
  backgroundColor,
}: IWebviewPropsWeb) => {
  useEffect(() => {
    if (iframeLoaded) {
      listenToMessagesFromOrigin(listenForMessage, new URL(externalUrl).origin);
    }
  }, [externalUrl, iframeLoaded, listenForMessage, webViewRef]);

  return (
    <>
      {!iframeLoaded && <Loader copy={loadingMessage} loading={!iframeLoaded} />}
      <iframe
        title="external-campaign"
        src={`${externalUrl}${queryParam}`}
        onLoad={onLoadEnd}
        ref={webViewRef}
        allow="clipboard-write; web-share"
        style={{
          border: 0,
          height: '100%',
          backgroundColor: backgroundColor || theme.token('background-default'),
        }}
      ></iframe>
    </>
  );
};
